import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_mountain_gray/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-c13a1e81f3.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-b243809cab.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-ba0a2de003.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-43d42a3367.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-a6f7da109a.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-07399860bf.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-6c86d68163.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-66a8842da8.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-7368bf28c2.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-9d748fa0d6.png'; };
